module.exports = __webpack_public_path__ + "media/3.ae985967.mp3";